module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tree-breadcrumb-child"
  }, [_c('span', {
    staticClass: "tree-breadcrumb-innner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clickHandle(_vm.item)
      }
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.item.name))])], 2), _vm._v(" "), _c('svg', {
    staticClass: "tree-svg",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#arrow-right"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-02fce9a2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/source/breadcrumb-item.vue
// module id = 318
// module chunks = 0